import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.333 7.185a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.86 11.792a.67.67 0 0 0 .947 0l2.726-2.734a4.526 4.526 0 1 0-6.4 0zM5.153 5.545a3.2 3.2 0 0 1 1.42-2.367 3.21 3.21 0 0 1 3.52 0 3.213 3.213 0 0 1 .5 4.94l-2.26 2.26-2.26-2.26a3.18 3.18 0 0 1-.92-2.573",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M13 13.318H3.667a.667.667 0 0 0 0 1.334H13a.667.667 0 0 0 0-1.334"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.411 11.062a.7.7 0 0 1 .515.846L4.4 14.066a.7.7 0 1 1-1.36-.331l.525-2.158a.7.7 0 0 1 .846-.515m7.84.006a.7.7 0 0 1 .846.515l.525 2.158a.7.7 0 1 1-1.36.331l-.526-2.158a.7.7 0 0 1 .515-.846",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })